import script from "./news-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./news-detail.vue?vue&type=script&setup=true&lang=ts"

import "./news-detail.vue?vue&type=style&index=0&id=ae3ff816&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae3ff816"]])

export default __exports__